import React from "react";
import { useField, useFormikContext } from "formik";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import DateTimePicker from 'react-datetime-picker';
import { Input, InputGroup, InputGroupAddon, InputGroupText, FormGroup, Label } from 'reactstrap';


const SyncReactDateTimePicker = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    const { isRequired = false, label, showLabel = false } = props
    const CustomInput = ({ value, onClick, iconOrText = '', isRequired = false, ...rest }) => {
        return (
        <InputGroup >

            <InputGroupAddon addonType="prepend">
                <InputGroupText>
                    {iconOrText}
                </InputGroupText>
            </InputGroupAddon>
            {/* <input type="text"  {...field} {...props} /> */}
            <Input type="text" onClick={onClick} value={value} {...rest} />
            <label>{isRequired && <span className="text-danger">&nbsp;*</span>}</label>


        </InputGroup>
        )
    }
    return (
        <FormGroup>
                {showLabel ? <Label style={{width: "100%"}} for={props.id || props.name} className={"label-color"}>{label}</Label> : "" }
        <DateTimePicker
            {...field}
            {...props}
            className="red-border"
            value={(field.value && new Date(field.value)) || new Date()}
            // value={(field.value && moment(field.value)) || null}
            onChange={val => {
                // console.log(field.value, val, "CharlesField")
                setFieldValue(field.name, val);

            }}
            // customInput={<CustomInput  {...props} />}
        />
         <label>{isRequired && <span className="text-danger">&nbsp;*</span>}</label>

</FormGroup>
    );
};

export default SyncReactDateTimePicker;